import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

import { DocumentTab } from './DocumentsTab';
import { FranchiseContactsTab } from './FranchiseContactsTab';

type TabValue = 'documents' | 'franchise-contacts';

const TAB_OPTIONS: { value: TabValue; label: string }[] = [
  { value: 'documents', label: 'Documents' },
  { value: 'franchise-contacts', label: 'Franchise Contacts' },
];

const DEFAULT_TAB: TabValue = 'documents';

export const DashboardLibrary = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedTab, setSelectedTab] = useState<TabValue>(DEFAULT_TAB);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const newDefaultTab = (queryParams.get('tab') as TabValue) || DEFAULT_TAB;
    setSelectedTab(newDefaultTab);
  }, [location]);

  const handleClickTab = (value: TabValue): void => {
    setSelectedTab(value);
    navigate(`/dashboard/library?tab=${value}`);
  };

  return (
    <div className="space-y-4">
      <div className="flex flex-col justify-center md:flex-row md:justify-between">
        <div className="flex flex-col items-center gap-5 md:flex-row">
          <div className="library-page-header space-y-1">
            <h2 className="as-strong">Company Directory</h2>
            <p className="as-body-02 as-strong text-typo-gray-tertiary">
              Documents and attachments that have been uploaded by franchisors.
            </p>
          </div>
        </div>
      </div>
      <Tabs
        value={selectedTab}
        defaultValue={DEFAULT_TAB}
        onValueChange={(value) => handleClickTab(value as TabValue)}
      >
        <TabsList className="library-main-tabs mb-4 h-auto max-w-full justify-start overflow-x-auto max-md:w-full md:flex-wrap">
          {TAB_OPTIONS.map(({ value, label }) => (
            <TabsTrigger
              key={value}
              value={value}
              className={`flex-1 ${value === 'documents' ? 'library-documents-tab' : 'library-contacts-tab'}`}
            >
              {label}
            </TabsTrigger>
          ))}
        </TabsList>
        <TabsContent
          value="documents"
          className="rounded-xl border border-alpha-dark-5 bg-muted p-4"
        >
          <DocumentTab />
        </TabsContent>
        <TabsContent
          value="franchise-contacts"
          className="rounded-xl border border-alpha-dark-5 bg-muted p-4"
        >
          <FranchiseContactsTab />
        </TabsContent>
      </Tabs>
    </div>
  );
};
